module.exports = (__webpack_require__(2))(98);


//////////////////
// WEBPACK FOOTER
// delegated ./lib/rlink-flux/index.js from dll-reference rlink_core
// module id = 56
// module chunks = 0